import { RootState } from "redux/rootReducer";

export const selectIsVerifyResetPasswordToken = (state: RootState) =>
  state.verifyResetPasswordToken.loading;
export const selectVerifyResetPasswordTokenErrorMessage = (state: RootState) =>
  state.verifyResetPasswordToken.error;
export const verifyResetPasswordTokenDataResponse = (state: RootState) =>
  state.verifyResetPasswordToken.verifyResetPasswordTokenResponse;
